import React, { useRef } from "react"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default function MovingGraphicBlockComponent({ richTextHeading, video, backgroundColor, image, bottomPadding, topPadding, enableControls }) {
  const videoExists = video ? true : false

  const bgVideoRef = useRef(null)
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)
  const bgc = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor)

  return (
    <div className={`moving-graphic-block-container ${tp != undefined ? tp : ""} ${bp != undefined ? bp : ""} ${bgc != undefined ? bgc : ""}`}>
      <div className={"w--wider"}>
        <div className={"rich-text headertext"}>{ReactHtmlParser(richTextHeading)}</div>
        <div className="graphic-wrapper">
          {videoExists ? (
            <video
              className="graphic"
              ref={bgVideoRef}
              data-epi-property="Video"
              loop
              muted
              playsInline
              preload={"auto"}
              autoPlay={true}
              loading="eager"
              fetchPriority="high"
              src={video}
              controls={enableControls}
            >
              <source media="(max-width:767px)" src={video} />
            </video>
          ) : (
            <img className="graphic" src={image}></img>
          )}
        </div>
      </div>
    </div>
  )
}
